import API from './index';
import methods from '../constants/methods';
import cruxProxy from './cruxProxy';
import { UriBuilder } from 'js/helpers/UriBuilder';

const headerOptions = {
    method: methods.GET.method,
    ...cruxProxy.getXsrfHeader(),
};

const getLenderSelectionUrl = (propertyId) => {
    const uriBuilder = new UriBuilder(`/api/property/${propertyId}/hub/lender-selection`);

    const requestOptions = {
        path: uriBuilder.build(),
        protected: true,
    };
    return API.initiateSessionApiCall(requestOptions, headerOptions);
};

export default {
    getLenderSelectionUrl,
};
